import React from 'react';

const About = () => {
    return (
        <div>
            <h1>Contact us</h1>
        </div>
    );
};

export default About;